import React from 'react';
import './Partners.css';
import partner1 from '../../assets/logo1.png';
import partner2 from '../../assets/logo2.png';
import partner3 from '../../assets/cern.jpg';
import partner5 from '../../assets/logo5.png';
import partner6 from '../../assets/novon.png';
import partner7 from '../../assets/logo7.png';
import partner8 from '../../assets/logo8.png';
import partner9 from '../../assets/logo9.png';
import partner10 from '../../assets/logo10.png';
import partner11 from '../../assets/logo11.png';
import partner12 from '../../assets/logo12.png';
import partner13 from '../../assets/logo13.png';
import partner14 from '../../assets/logo14.png';
import partner15 from '../../assets/logo15.png';
import partner16 from '../../assets/logo16.png';
import partner17 from '../../assets/logo17.png';
import partner19 from '../../assets/logo19.png';
import partner20 from '../../assets/angani.jpg';
import partner21 from '../../assets/qworld.jpg';
import partner22 from '../../assets/africarena.jpg';
import partnerUNDP from '../../assets/undp.png';
import partnerNodeNBO from '../../assets/nodeNBO.png';
import partnerILab from '../../assets/iLab.png';
import partnerBlockchain from '../../assets/blockchain_center.png';
import partnerUON from '../../assets/uon.jpeg';

const PartnersSection = () => {
  const partners = [
    { name: "AQC",          logo: partner7,  alt: "AQC logo" },
    { name: "Quantum Africa",logo: partner14, alt: "Quantum Africa" },
    { name: "IEEE PSK",     logo: partner16, alt: "IEEE PSK" },
    { name: "PSK",          logo: partner13, alt: "PSK logo" },
    { name: "IEEE UON",     logo: partner12, alt: "IEEE UON logo" },
    { name: "Strathmore",   logo: partner2,  alt: "Strathmore logo" },
    { name: "OQI",          logo: partner15, alt: "OQI logo" },
    { name: "Action Lab",   logo: partner17, alt: "Action Lab logo" },
    { name: "CERN",         logo: partner3,  alt: "CERN logo" },
    { name: "Novon",        logo: partner6,  alt: "Novon logo" },
    { name: "Angani",       logo: partner20, alt: "Angani logo" },
    { name: "AfricArena",   logo: partner22, alt: "AfricArena logo" },
    { name: "ALX",          logo: partner10, alt: "ALX logo" },
    { name: "Moringa",      logo: partner11, alt: "Moringa School logo" },
    { name: "Classiq",      logo: partner5,  alt: "Classiq logo" },
    { name: "IBM Quantum",  logo: partner19, alt: "IBM Quantum" },
    { name: "adanian",      logo: partner8,  alt: "adanian logo" },
    { name: "QWorld",       logo: partner21, alt: "QWorld logo" },
    { name: "iyq",          logo: partner9,  alt: "iyq logo" },
    { name: "One Quantum",  logo: partner1,  alt: "One Quantum" },
    { name: "UNDP",             logo: partnerUNDP,       alt: "UNDP logo" },
    { name: "NodeNBO",          logo: partnerNodeNBO,    alt: "NodeNBO logo" },
    { name: "iLab",             logo: partnerILab,       alt: "iLab logo" },
    { name: "Blockchain Center",logo: partnerBlockchain, alt: "Blockchain Center logo" },
    { name: "UON",              logo: partnerUON,        alt: "University of Nairobi logo" },
  ];

  return (
    <section className="partners-section">
      <div className="partners-header">
        <span className="partner-label">Collaborations</span>
        <h2 className="partner-heading">
          Empowering the next Generation of Quantum Innovators
        </h2>
      </div>

      <div className="partners-grid-wrapper">
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              className="partner-cell"
              role="img"
              aria-label={partner.alt}
            >
              <img
                src={partner.logo}
                alt={partner.alt}
                className="partner-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
